import * as React from 'react'
import './index.css'
import JudasConstant from '@Pages/coupon/constants/JudasConstant'
import { pageTracker, moduleTracker } from '@/common/lx'
import i18nClient from '../../i18n.config'

interface IProps {
  onClickCloseBtn: () => void
  onClickCommitBtn: (input: string) => void
  promoFailTips: string
}

interface IState {
  btnEnable: boolean // 底部按钮是否可点击
  showFailTips: boolean // 失败文案是否展示
  showDelIcon: boolean // 输入框删除按钮是否展示
  KeyboardHeight: number // 键盘高度
}

/**
 * 提单-优惠券码兑换页
 */
export default class OrderCouponPromoDialog extends React.Component<IProps, IState> {
  keyword = '' // 输入框内容

  searchInput: HTMLElement | null = null

  constructor (props: IProps) {
    super(props)
    this.state = {
      btnEnable: false,
      showFailTips: false,
      showDelIcon: false,
      KeyboardHeight: 0,
    }
  }

  componentDidMount () {
    pageTracker({ cid: JudasConstant.ORDER_COUPON_PROMO_CID })
  }

  /**
   * 输入内容监听
   * @param e
   */
  inputChange = (e: any) => {
    const keyword = e.detail
    if (keyword === this.keyword) return
    this.keyword = keyword
    if (!keyword) {
      this.inputValClearHandle()
      return
    }
    this.setState({
      showDelIcon: true,
      btnEnable: true,
    })
  }

  /**
   * 点击输入框删除按钮
   */
  clearInput = () => {
    if (this.searchInput) {
      // @ts-ignore
      this.searchInput.setValue('')
    }
    this.keyword = ''
    this.setState({
      showDelIcon: false,
      btnEnable: false,
    })
  }

  /**
   * 清空或者点删除icon清空
   */
  inputValClearHandle = () => {
    this.keyword = ''
    this.setState({
      showDelIcon: false,
      btnEnable: false,
    })
  }

  /**
   * 输入框获得焦点
   */
  onFocus = () => {
    //
  }

  /**
   * 键盘提交监听
   */
  onConfirm = () => {
    //
  }

  /**
   * 提交按钮点击
   */
  onClickCommitBtn = () => {
    // 按钮置灰或输入词为空则不可点击
    if (!this.state.btnEnable || !this.keyword) {
      return
    }
    this.setState({
      btnEnable: false,
    })
    const { onClickCommitBtn } = this.props
    // @ts-ignore
    onClickCommitBtn && onClickCommitBtn(this.keyword)
    // 提交按钮mc
    moduleTracker({
      cid: JudasConstant.ORDER_COUPON_PROMO_CID,
      bid: JudasConstant.COUPON_PROMO_COMMIT_MC,
      valLab: {
        button_status: this.state.btnEnable,
        coupon_code: this.keyword,
      },
    })
  }

  /**
   * 关闭按钮点击
   */
  onClickCloseBtn = () => {
    this.focusInputBlur()
    const { onClickCloseBtn } = this.props
    // @ts-ignore
    onClickCloseBtn && onClickCloseBtn()
  }

  /**
   * 键盘高度变化监听
   * @param height
   */
  onKeyboardHeightChanged = (height: any) => {
    const KeyboardHeight = height.detail + 10
    this.setState({
      KeyboardHeight,
    })
  }

  /**
   * 取消键盘焦点（收起键盘）
   */
  focusInputBlur = () => {
    if (this.searchInput) {
      // @ts-ignore
      this.searchInput.blur()
    }
  }

  render () {
    // 数据处理
    const { promoFailTips } = this.props
    const { btnEnable, showDelIcon, KeyboardHeight } = this.state
    // i18n
    const placeHolderText = i18nClient.getText('coupon_promocode_enterbar')
    const bottomBtnText = i18nClient.getText('coupon_promocode_uselist_button')

    return (
      <view className="container">
        <view className="container-outer">
          <view className="container-inner">
            {/* 顶部输入框*/}
            <view className="edit-input-outer">
              <image className="edit-icon" onClick={this.onClickCloseBtn} src="assets://icon/coupon/promo_edit_left_arrow.png" autoRTL />
              <view className="edit-input-box">
                <input
                  ref={(ref: any) => {
                    this.searchInput = ref
                  }}
                  className="edit-input"
                  placeholder={placeHolderText}
                  cursorColor="#222222"
                  confirmType="default"
                  placeholderColor="#808080"
                  placeholderStyle={{
                    color: '#808080',
                    fontSize: 14,
                    fontWeight: 'normal',
                    fontFamily: 'KeeTa-Regular',
                  }}
                  focus
                  disabled={false}
                  onKeyboardHeightChanged={this.onKeyboardHeightChanged}
                  onChange={this.inputChange}
                  onFocus={this.onFocus}
                  onConfirm={this.onConfirm}
                ></input>
              </view>

              {/* 删除按钮*/}
              {showDelIcon && (
                <view className="del-icon-box" onClick={this.clearInput}>
                  <image className="del-icon" src="assets://icon/coupon/promo_edit_del_icon.png" autoRTL />
                </view>
              )}
            </view>

            {/* 兑换失败提醒文案*/}
            {promoFailTips && (
              <view className="fail-tips-wrap">
                <image className="fail-tips-icon" src="assets://icon/coupon/promo_fail_tips_icon.png" autoRTL></image>
                <text className="fail-tips-text">{promoFailTips}</text>
              </view>
            )}
          </view>

          {/* 底部按钮区*/}
          <view
            className="commit-btn-wrap"
            style={{
              backgroundColor: btnEnable ? '#FFE41F' : '#CACACA',
              marginBottom: KeyboardHeight > 0 ? KeyboardHeight : 0,
            }}
            onClick={this.onClickCommitBtn}
          >
            <text className="commit-btn-text" style={{ color: btnEnable ? '#222222' : '#FFFFFF' }}>
              {bottomBtnText}
            </text>
          </view>
        </view>
      </view>
    )
  }
}
